export const LOAD_ORDERS_LIST = 'LOAD_ORDERS_LIST';
export const ADD_ORDER = 'ADD_ORDER';
export const CONFIRM_ORDER = 'CONFIRM_ORDER';
export const RESTART_ORDER = 'RESTART_ORDER';
export const BUMP_ORDER = 'BUMP_ORDER';
export const CANCEL_ORDER = 'CANCEL_ORDER';
export const RESET_ORDERS = 'RESET_ORDERS';
export const LOAD_STATS = 'LOAD_STATS';
export const LOAD_CSV_STATS = 'LOAD_CSV_STATS';
